import { useState } from "react";

const LS_KEY = "bd:agenda:selectedServices";

/**
 * Ids de serviços selecionados no filtro da agenda. Persiste em localStorage.
 * Vazio = sem filtro (mostra tudo) — espelha o padrão de useSelectedDentists.
 */
function readStored(): string[] | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.every((x) => typeof x === "string")) {
      return parsed;
    }
  } catch {
    // noop
  }
  return null;
}

function writeStored(ids: string[]): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(ids));
  } catch {
    // noop
  }
}

export function useSelectedServices(fallback: string[] = []): {
  ids: string[];
  setIds: (next: string[]) => void;
  toggle: (id: string) => void;
  selectAll: (allIds: string[]) => void;
  clear: () => void;
} {
  const [ids, setIdsState] = useState<string[]>(() => readStored() ?? fallback);

  const setIds = (next: string[]) => {
    writeStored(next);
    setIdsState(next);
  };

  const toggle = (id: string) => {
    setIds(ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]);
  };

  const selectAll = (allIds: string[]) => setIds(allIds);
  const clear = () => setIds([]);

  return { ids, setIds, toggle, selectAll, clear };
}
